import Employment from '@/views/layouts/SubLayouts/Employment.vue';

//******CONTENT */
const ContentCategory = () => import(/* webpackChunkName: "ContentCategory" */ '@/views/Content/Category/Index.vue');
const Content = () => import(/* webpackChunkName: "Content" */ '@/views/Content/Content/Index.vue');
const ContentTemplate = () => import(/* webpackChunkName: "ContentTemplate" */ '@/views/Content/Template/Index.vue');
const ContentTemplate2 = () => import(/* webpackChunkName: "ContentTemplate2" */ '@/views/Content/Template2/Index.vue');
// import ContentCategory from '@/views/Content/Category/Index.vue';
// import Content from '@/views/Content/Content/Index.vue';
// import ContentTemplate from '@/views/Content/Template/Index.vue';
// import ContentTemplate2 from '@/views/Content/Template2/Index.vue';

//*********** HR */
import HR from '@/views/HR/Index.vue';
import Employee from '../pages/Employee';
import Assignment from '../pages/Assignment';
import LeaveEnroll from '../pages/LeaveEnroll';
import EmployeeOverview from '@/views/HR/Overview/Index.vue';
import HrEmployeeOverview from '@/views/HR/Overview/Hr.vue';
import Schedule from '@/views/HR/Schedule/Index.vue';
import User from '@/views/HR/User/Index.vue';
import Role from '@/views/HR/Role/Index.vue';
import Insurance from '@/views/HR/Insurance/Index.vue';
import Contract from '@/views/HR/Contract/Index.vue';
import EmployeeIssue from '@/views/HR/EmployeeIssue/Index.vue';

//*********** Confirm */
import InternalDenouceHr from '@/views/Confirm/InternalDenouce/Index.vue';
import Attendance from '@/views/SalaryAndWork/Attendance/Index.vue';
import Confirm from '@/views/Confirm/Index.vue'
import ConfirmLongLeaveRequest from '@/views/Confirm/LongLeave/Index.vue';
import ConfirmShortRequest from '@/views/Confirm/ShortLeave/Index.vue';
import ConfirmOvertime from '@/views/Confirm/Overtime/Index.vue';
import ConfirmInfoUpdateRequest from '@/views/Confirm/InfoUpdate/Index.vue';
import ConfirmLeave from '@/views/Confirm/Leave/Index.vue';
import ConfirmQuit from '@/views/Confirm/Quit/Index.vue';
import ConfirmBusiness from '@/views/Confirm/Business/Index.vue';
import ConfirmOvertimeBooking from '@/views/Confirm/OvertimeBooking/Index.vue';

import SalaryEmployeeFamily from '@/views/SalaryAndWork/EmployeeFamily/Index.vue'
import HrEmployeeFamilyCreate from '@/views/HR/EmployeeFamily/Create';
import HrEmployeeFamilyIndex from '@/views/HR/EmployeeFamily/Index';
import CustomerReview from '@/views/HR/CustomerReview/Index';

import EmployeeReview from '@/views/HR/EmployeeReview/Index';
import ManagerEmployeeReview from '@/views/HR/EmployeeReview/Manager/Index';
import EmployeeReviewCondition from '@/views/HR/EmployeeReviewCondition/Index';
import AsmConfig2 from '@/views/HR/AsmConfig/Index2';

//****Image */
// import ImageReport from '@/views/HR/ImageReport/Index.vue';

//timesheet
import TimeSheet from '@/views/SalaryAndWork/TimeSheet/Index.vue';
import ReviewTimesheet from '@/views/HR/ReviewTimesheet/Index.vue';
import Feedback from '@/views/HR/Feedback/Index.vue';

import QrLink from '@/views/HR/QrLink/Index.vue';
// import TimeSheet2 from '@/views/SalaryAndWork/TimeSheet/Index2.vue';

import BenefitManager from '@/views/HR/BenefitManager/Index.vue';
import CurrentEmployee from '@/views/HR/EmployeeActive/Index.vue';

import VideoSurvey from '@/views/HR/VideoSurvey/Index.vue';

import EmployeeRotationRequest from '@/views/Request/EmployeeRotation/Index.vue'

import ConfirmRotationRequest from '@/views/Confirm/EmployeeRotation/Index.vue'
const ManagerConfirmRotationRequest = () => import('@/views/Confirm/EmployeeRotation/ManagerIndex.vue');
import Survey from '@/views/HR/Survey/Index'
import SurveyReport from '@/views/HR/Survey/Report'

import AsmConfig from '@/views/HR/AsmConfig/Index'

import EmployeeReport from '@/views/HR/EmployeeReport/Index'
import ContractCategory from '@/views/HR/ContractCategory/Index'
import Contractv2 from '@/views/HR/Contractv2/Index'
import Contractv2Pending from '@/views/HR/Contractv2/Pending'
import Contractv2Ready from '@/views/HR/Contractv2/Ready'
import Contractv2Return from '@/views/HR/Contractv2/Return'
import Contractv2Complete from '@/views/HR/Contractv2/Complete'
import Contractv2Resign from '@/views/HR/Contractv2/Resign'

import OrganizationMap from '@/views/HR/OrganizationMap/Index'
import OrganizationMapCreate from '@/views/HR/OrganizationMap/Create'

import RecruitmentRequest from '@/views/Request/RecruitmentRequest/Index'
import RecruitmentRequestCreate from '@/views/Request/RecruitmentRequest/Create'

import HrEmployeeInfoUpdate from '@/views/HR/EmployeeInfoUpdate/Index';
import HrEmployeeInfoUpdateCreate from '@/views/HR/EmployeeInfoUpdate/Create';

import LeaveSchedule from '@/views/HR/LeaveSchedule/Index';

import TemporaryStoreDetail from '@/views/HR/TemporaryStoreDetail/Index';
import TemporaryStore from '@/views/HR/TemporaryStore/Index';
import HrDepartment from '@/views/HR/Department/Index';
import HrQuit from '@/views/Confirm/QuitRequest/HrIndex';
import Manager1Quit from '@/views/Confirm/QuitRequest/Manager1Index';
import Manager2Quit from '@/views/Confirm/QuitRequest/Manager2Index';
import KiemKe from '@/views/HR/KiemKeList/Index'
import LeaveRequestSuperAdmin from '@/views/Confirm/LeaveSuperAdmin/Index.vue'
import ConfirmTimesheet from '@/views/Confirm/Timesheet/Index.vue'
import EmployeeIp from '@/views/HR/EmployeeIp/Index.vue'
import StoreAudit from '@/views/HR/StoreAudit/Index';
import RmEmployee from '@/views/HR/Employee/RmIndex'
import YearLeaveReport from '@/views/HR/YearLeaveReport/Index'
import HolidayEnrollment from '@/views/HR/HolidayEnrollment/Index'

import RouteMenu from '@/views/HR/RouteMenu/Index.vue'

var isHr = localStorage.getItem('userClaim')?.includes('hr:dashboard')

export default [
    {
      path: 'employment',
      name: 'Employment',
      component: Employment,
      meta: { 
        breadcrumbs: [
            {
            text: 'Trang chủ',
            disabled: false,
            to: {
                name: "Home",
                }
            },
        ],
        icon:{
            icon: "mdi-plus-thick",
            to: ""
        },
      },
      redirect: {name: 'EmployeeOverview'},
      children:[
        
        {
          path: 'holiday-enrollment',
          name: 'HolidayEnrollment',
          component: HolidayEnrollment
        },
        {
          path: 'rm-employee',
          name: 'RmEmployee',
          component: RmEmployee
        },
        {
          path: 'route-menu',
          name: 'RouteMenu',
          component: RouteMenu,
        },
        {
          path: 'employee-report',
          name: 'EmployeeReport',
          component: EmployeeReport,
        },
        {
          path: 'survey',
          name: 'Survey',
          component: Survey,
        },
        {
          path: 'survey/report/:id',
          name: 'SurveyReport',
          component: SurveyReport,
          meta:{
            breadcrumbs: [
                {
                text: 'Danh sách khảo sát',
                to: {
                    name: "Survey",
                    }
                },
              ],
          }
        },
        {
          path: 'customer-review',
          name: 'CustomerReview',
          component: CustomerReview,
          meta:{
            breadcrumbs: [
                {
                text: '',
                to: {
                    name: "CustomerReview",
                    }
                },
              ],
          }
        },
        {
          path: 'employee-review-condition',
          name: 'EmployeeReviewCondition',
          component: EmployeeReviewCondition,
          meta:{
            breadcrumbs: [
                {
                text: '',
                to: {
                    name: "EmployeeReviewCondition",
                    }
                },
              ],
          }
        },
        {
          path: 'employee-review',
          name: 'EmployeeReview',
          component: EmployeeReview,
          meta:{
            breadcrumbs: [
                {
                text: '',
                to: {
                    name: "EmployeeReview",
                    }
                },
              ],
          }
        },
        {
          path: 'manager-employee-review',
          name: 'ManagerEmployeeReview',
          component: ManagerEmployeeReview,
          meta:{
            breadcrumbs: [
                {
                text: '',
                to: {
                    name: "ManagerEmployeeReview",
                    }
                },
              ],
          }
        },
        
        //employee update info
        {
          path: 'request/employee-info-update',
          name: 'HrEmployeeInfoUpdate',
          component: HrEmployeeInfoUpdate
        },
        {
          path: 'employee-info-update/create',
          name: 'HrEmployeeInfoUpdateCreate',
          component: HrEmployeeInfoUpdateCreate
        },
        {
          path: 'employee-info-update/edit/:id',
          name: 'HrEmployeeInfoUpdateEdit',
          component: HrEmployeeInfoUpdateCreate
        },
        {
          path: 'temporary-store-detail',
          name: 'TemporaryStoreDetail',
          component: TemporaryStoreDetail
        },
        {
          path: 'temporary-store',
          name: 'TemporaryStore',
          component: TemporaryStore
        },
        {
          path: 'kiem-ke',
          name: 'KiemKe',
          component: KiemKe
        },

        //*********** XET DUYET ******* */
        {
          path:"Confirm",
          component: Confirm,
          children:[
          
            {
              path: 'internal-denouce-hr',
              name: 'InternalDenouceHr',
              component: InternalDenouceHr
            },
            {
              path: 'store-audit',
              name: 'StoreAudit',
              component: StoreAudit
            },
            {
              path: 'info-update-request',
              name: 'ConfirmInfoUpdateRequest',
              component: ConfirmInfoUpdateRequest
            },
            {
              path: 'rotation-request',
              name: 'ConfirmRotationRequest',
              component: ConfirmRotationRequest
            },
            
            {
              path: 'hr-confirm-quit-request',
              name: 'HrConfirmQuitRequest',
              component: HrQuit
            },
            
            {
              path: 'man1-confirm-quit-request',
              name: 'Manager1QuitRequest',
              component: Manager1Quit
            },
            
            {
              path: 'man2-confirm-quit-request',
              name: 'Manager2QuitRequest',
              component: Manager2Quit
            },
            
            {
              path: 'confirm-overtime-booking',
              name: 'ConfirmOvertimeBooking',
              component: ConfirmOvertimeBooking,
              meta:{
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Xác nhận giới hạn tăng ca',
                    disabled: true,
                    to: {
                        name: "ConfirmOvertime",
                        }
                    },
                  ],
              }
            },
            {
              path: 'confirm-short-leave',
              name: 'ConfirmShortRequest',
              component: ConfirmShortRequest
            },
            {
              path:'confirm-overtime',
              name: 'ConfirmOvertime',
              component: ConfirmOvertime,
              meta:{
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Xác nhận tăng ca',
                    disabled: true,
                    to: {
                        name: "ConfirmOvertime",
                        }
                    },
                  ],
              }
            },
            {
              path:'confirm-leave',
              name: 'ConfirmLeave',
              component: ConfirmLeave,
              meta:{
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Xác nhận nghỉ phép',
                    disabled: true,
                    to: {
                        name: "ConfirmLeave",
                        }
                    },
                  ],
              }
            },
            {
              path:'confirm-timesheet',
              name: 'ConfirmTimesheet',
              component: ConfirmTimesheet,
              meta:{
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Xác nhận giờ công',
                    disabled: true,
                    to: {
                        name: "ConfirmTimesheet",
                        }
                    },
                  ],
              }
            },
            {
              path:'confirm-leave-super-admin',
              name: 'ConfirmLeaveSuperAdmin',
              component: LeaveRequestSuperAdmin,
              meta:{
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Xác nhận nghỉ phép',
                    disabled: true,
                    to: {
                        name: "ConfirmLeaveSuperAdmin",
                        }
                    },
                  ],
              }
            },
            
            {
              path:'confirm-quit',
              name: 'ConfirmQuit',
              component: ConfirmQuit,
              meta:{
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Xác nhận nghỉ phép',
                    disabled: true,
                    to: {
                        name: "ConfirmQuit",
                        }
                    },
                  ],
              }
            },
            {
              path:'confirm-business',
              name: 'ConfirmBusiness',
              component: ConfirmBusiness,
              meta:{
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Xác nhận công tác',
                    disabled: true,
                    to: {
                        name: "ConfirmBusiness",
                        }
                    },
                  ],
              }
            },
            {
              path: 'confirm-long-leave',
              name: 'ConfirmLongLeaveRequest',
              component: ConfirmLongLeaveRequest,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Duyệt nghỉ dài hạn',
                    disabled: true,
                    to: {
                        name: "LongLeaveConfirm",
                        }
                    },
                ],
                icon:{
                    icon: "mdi-plus-thick",
                    to: ""
                  },
              },
            },
            
            {
              path: 'confirm-long-leave',
              name: 'ConfirmLongLeaveRequest',
              component: ConfirmLongLeaveRequest,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Duyệt nghỉ dài hạn',
                    disabled: true,
                    to: {
                        name: "LongLeaveConfirm",
                        }
                    },
                ],
                icon:{
                    icon: "mdi-plus-thick",
                    to: ""
                  },
              },
            },
          ]

        },

        {
          path:"request/employee-rotation-request",
          name:"EmployeeRotationRequest",
          component: EmployeeRotationRequest,
        },
        
          {
            path: 'manager-rotation-request',
            name: 'ManagerConfirmRotationRequest',
            component: ManagerConfirmRotationRequest
          },

        {
          path:"request/recruitment-request",
          name:"RecruitmentRequest",
          component: RecruitmentRequest,
        },
        
        {
          path:"recruitment-request/create",
          name:"RecruitmentRequestCreate",
          component: RecruitmentRequestCreate,
        },
        {
          path:"recruitment-request/edit/:id",
          name:"RecruitmentRequestEdit",
          component: RecruitmentRequestCreate,
        },

        ////*********** QRLINK ***********
        {
          path:"qr-link",
          name:"qrLink",
          component: QrLink,
          meta: { 
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
                {
                text: 'Sinh mã QR',
                disabled: true,
                to: {
                    name: "qrLink",
                    }
                },
            ],
          }
        },
        
        ////*********** ORG MAP ***********
        {
          path:"organization-map",
          name:"OrganizationMap",
          component: OrganizationMap,
        },
        {
          path:"organization-map/create",
          name:"OrganizationMapCreate",
          component: OrganizationMapCreate,
        },
        {
          path:"organization-map/edit/:id",
          name:"OrganizationMapCreateEdit",
          component: OrganizationMapCreate,
        },
        
        {
          path: 'hr-employee-overview',
          name: 'HrEmployeeOverview',
          component: HrEmployeeOverview,
          meta: { 
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
                {
                text: 'Ngày công',
                disabled: true,
                to: {
                    name: "Timesheet",
                    }
                },
            ],
          }
        },
        
        {
          path: 'employee-overview',
          name: 'EmployeeOverview',
          // component: isHr ? HrEmployeeOverview: EmployeeOverview,
          component: EmployeeOverview,
          meta: { 
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
                {
                text: 'Ngày công',
                disabled: true,
                to: {
                    name: "Timesheet",
                    }
                },
            ],
          }
        },
        {
          path: 'timesheet',
          name: 'HrTimeSheet',
          component: TimeSheet,
          meta: { 
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
                {
                text: 'Ngày công',
                disabled: true,
                to: {
                    name: "Timesheet",
                    }
                },
            ],
          }
        },
        {
          path: 'attendances',
          name: 'Attendance',
          component: Attendance,
          meta: { 
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
                {
                text: 'Danh sách chấm công',
                disabled: true,
                to: {
                    name: "Attendance",
                    }
                },
            ],
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },
          }
        },
        //********** HR */
        {
          path: "HR",
          component: HR,
          children:[
            
            //gia dinh nhan vien
            {
              path: 'hr-employee-family-index',
              name: 'HrEmployeeFamilyIndex',
              component: SalaryEmployeeFamily
            },
            // {
            //   path: 'hr-employee-family',
            //   name: 'HrEmployeeFamilyCreate',
            //   component: HrEmployeeFamilyCreate
            // },
            {
              path: 'feedback',
              name: 'Feedback',
              component: Feedback,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Phản hồi',
                    disabled: true,
                    to: {
                        name: "Feedback",
                        }
                    },
                ],
              }
            },
            
            // {
            //   path: 'image-report',
            //   name: 'ImageReport',
            //   component: ImageReport,
            //   meta: { 
            //     breadcrumbs: [
            //         {
            //         text: 'Trang chủ',
            //         disabled: false,
            //         to: {
            //             name: "Home",
            //             }
            //         },
            //         {
            //         text: 'Báo cáo hình ảnh',
            //         disabled: true,
            //         to: {
            //             name: "ImageReport",
            //             }
            //         },
            //     ],
            //   }
            // },

            {
              path: 'review-timesheet',
              name: 'ReviewTimesheet',
              component: ReviewTimesheet,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Ngày công',
                    disabled: true,
                    to: {
                        name: "ReviewTimesheet",
                        }
                    },
                ],
              }
            },
            

            {
              path: 'schedule',
              alias: ["hr/schedule"],
              name: 'Schedule',
              component: Schedule,
              meta:{
                breadcrumbs: [
                  {
                  text: 'Trang chủ',
                  disabled: false,
                  to: {
                      name: "Home",
                      }
                  },
                  {
                  text: 'Sắp ca làm việc',
                  disabled: true
                  },
                ],
              }
            },
            ...Employee,
            ...Assignment,
            {
              path: 'users',
              name: 'User',
              component: User,
              meta:{
                breadcrumbs: [
                  {
                  text: 'Trang chủ',
                  disabled: false,
                  to: {
                      name: "Home",
                      }
                  },
                  {
                  text: 'Quản lí tài khoản ',
                  disabled: true,
                  to: {
                      name: "User",
                      }
                  },
                ],
              }
            },
            {
              path: 'roles',
              name: 'Role',
              component: Role,
              meta:{
                breadcrumbs: [
                  {
                  text: 'Trang chủ',
                  disabled: false,
                  to: {
                      name: "Home",
                      }
                  },
                  {
                  text: 'Quản lí phân quyền ',
                  disabled: true,
                  to: {
                      name: "role",
                      }
                  },
                ],
              }
            },
            
            {
              path: 'departments',
              name: 'HrDepartment',
              component: HrDepartment
            },
            {
              path: 'asm-config',
              name: 'AsmConfig',
              component: AsmConfig,
            },
            {
              path: 'asm-config-2',
              name: 'AsmConfig2',
              component: AsmConfig2,
            },
            // {
            //   path: 'insurances',
            //   name: 'Insurance',
            //   component: Insurance,
            //   meta:{
            //     breadcrumbs: [
            //       {
            //       text: 'Trang chủ',
            //       disabled: false,
            //       to: {
            //           name: "Home",
            //           }
            //       },
            //       {
            //       text: 'Quản lí bảo hiểm ',
            //       disabled: true,
            //       to: {
            //           name: "Insurance",
            //           }
            //       },
            //     ],
            //   }
            // },
            // {
            //   path: 'contracts',
            //   name: 'Contract',
            //   component: Contract,
            //   meta: {
            //     breadcrumbs: [
            //         {
            //         text: 'Trang chủ',
            //         disabled: false,
            //         to: {
            //             name: "Home",
            //             }
            //         },
            //         {
            //         text: 'Quản lí hợp đồng ',
            //         disabled: true,
            //         to: {
            //             name: "Contract",
            //             }
            //         },
            //     ],
            //     icon:{
            //         icon: "mdi-plus-thick",
            //         to: ""
            //     },
            //   }
            // },
            // {
            //   path: 'employee-issue',
            //   name: 'EmployeeIssue',
            //   component: EmployeeIssue,
            //   meta: { 
            //     breadcrumbs: [
            //         {
            //         text: 'Trang chủ',
            //         disabled: false,
            //         to: {
            //             name: "Home",
            //             }
            //         },
            //         {
            //         text: 'Cấp phát nhân viên',
            //         disabled: true,
            //         to: {
            //             name: "EmployeeIssue",
            //             }
            //         },
            //     ],
            //     icon:{
            //         icon: "mdi-plus-thick",
            //         to: ""
            //     },
            //   }
            // },
            
            {
              path: 'current-employee',
              name: 'CurrentEmployee',
              component: CurrentEmployee,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'DS nhân viên hoạt động',
                    disabled: true,
                    to: {
                        name: "CurrentEmployee",
                        }
                    },
                ],
                icon:{
                    icon: "mdi-plus-thick",
                    to: ""
                },
              }
            },
            // ...LeaveEnroll,
            // ...Salary,
            // ...Allowance,
          ]
        },
        
        //*********** CONTENT ********* */
        {
          path:"content",
          component: Confirm,
          children:[
            {
              path: 'category',
              name: 'Category',
              component: ContentCategory,
              meta:{
                breadcrumbs: [
                  {
                  text: 'Trang chủ',
                  disabled: false,
                  to: {
                      name: "Home",
                      }
                  },
                  {
                  text: 'Danh mục',
                  disabled: true,
                  to: {
                      name: "Category",
                      }
                  },
                ],
                  
                icon:{
                  icon: "mdi-plus-thick",
                  to: ""
                },
              }
            },
            {
              path: 'content',
              name: 'Content',
              component: Content,
              meta:{
                breadcrumbs: [
                  {
                  text: 'Trang chủ',
                  disabled: false,
                  to: {
                      name: "Home",
                      }
                  },
                  {
                  text: 'Bài viết',
                  disabled: true,
                  to: {
                      name: "Content",
                      }
                  },
                ],
                  
                icon:{
                  icon: "mdi-plus-thick",
                  to: ""
                },
              }
            },
            {
              path: 'template',
              name: 'ContentTemplate',
              component: ContentTemplate,
              meta:{
                breadcrumbs: [
                  {
                  text: 'Trang chủ',
                  disabled: false,
                  to: {
                      name: "Home",
                      }
                  },
                  {
                  text: 'Template',
                  disabled: true,
                  to: {
                      name: "ContentTemplate",
                      }
                  },
                ],
                  
                icon:{
                  icon: "mdi-plus-thick",
                  to: ""
                },
              }
            },
            
            {
              path: 'template2',
              name: 'ContentTemplate2',
              component: ContentTemplate2,
              meta:{
                breadcrumbs: [
                  {
                  text: 'Trang chủ',
                  disabled: false,
                  to: {
                      name: "Home",
                      }
                  },
                  {
                  text: 'Template',
                  disabled: true,
                  to: {
                      name: "ContentTemplate2",
                      }
                  },
                ],
                  
                icon:{
                  icon: "mdi-plus-thick",
                  to: ""
                },
              }
            },
          ]
        },

        {
          path: "HR",
          component: HR,
          children:[
            {
              path: 'feedback',
              name: 'Feedback',
              component: Feedback,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Phản hồi',
                    disabled: true,
                    to: {
                        name: "Feedback",
                        }
                    },
                ],
              }
            },
            
            // {
            //   path: 'image-report',
            //   name: 'ImageReport',
            //   component: ImageReport,
            //   meta: { 
            //     breadcrumbs: [
            //         {
            //         text: 'Trang chủ',
            //         disabled: false,
            //         to: {
            //             name: "Home",
            //             }
            //         },
            //         {
            //         text: 'Báo cáo hình ảnh',
            //         disabled: true,
            //         to: {
            //             name: "ImageReport",
            //             }
            //         },
            //     ],
            //   }
            // },
            {
              path: 'timesheet',
              name: 'HrTimeSheet',
              component: TimeSheet,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Ngày công',
                    disabled: true,
                    to: {
                        name: "Timesheet",
                        }
                    },
                ],
              }
            },

            {
              path: 'review-timesheet',
              name: 'ReviewTimesheet',
              component: ReviewTimesheet,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Ngày công',
                    disabled: true,
                    to: {
                        name: "ReviewTimesheet",
                        }
                    },
                ],
              }
            },
            
            {
              path: 'attendances',
              name: 'Attendance',
              component: Attendance,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Danh sách chấm công',
                    disabled: true,
                    to: {
                        name: "Attendance",
                        }
                    },
                ],
                icon:{
                    icon: "mdi-plus-thick",
                    to: ""
                },
              }
            },

            {
              path: 'employee-overview',
              name: 'EmployeeOverview',
              component: EmployeeOverview,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Ngày công',
                    disabled: true,
                    to: {
                        name: "Timesheet",
                        }
                    },
                ],
              }
            },
            {
              path: 'schedule',
              alias: ["hr/schedule"],
              name: 'Schedule',
              component: Schedule,
              meta:{
                breadcrumbs: [
                  {
                  text: 'Trang chủ',
                  disabled: false,
                  to: {
                      name: "Home",
                      }
                  },
                  {
                  text: 'Sắp ca làm việc',
                  disabled: true
                  },
                ],
              }
            },
            ...Employee,
            ...Assignment,
            {
              path: 'users',
              name: 'User',
              component: User,
              meta:{
                breadcrumbs: [
                  {
                  text: 'Trang chủ',
                  disabled: false,
                  to: {
                      name: "Home",
                      }
                  },
                  {
                  text: 'Quản lí tài khoản ',
                  disabled: true,
                  to: {
                      name: "User",
                      }
                  },
                ],
              }
            },
            {
              path: 'roles',
              name: 'Role',
              component: Role,
              meta:{
                breadcrumbs: [
                  {
                  text: 'Trang chủ',
                  disabled: false,
                  to: {
                      name: "Home",
                      }
                  },
                  {
                  text: 'Quản lí phân quyền ',
                  disabled: true,
                  to: {
                      name: "role",
                      }
                  },
                ],
              }
            },

            {
              path: 'video-survey',
              name: 'videoSurvey',
              component: VideoSurvey,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'Quan sát videos',
                    disabled: true,
                    to: {
                        name: "VideoSurvey",
                        }
                    },
                ],
                icon:{
                    icon: "mdi-plus-thick",
                    to: ""
                },
              }
            },

            {
              path: 'contract-category',
              name: 'ContractCategory',
              component: ContractCategory,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                ],
              }
            },
            
            {
              path: 'current-employee',
              name: 'CurrentEmployee',
              component: CurrentEmployee,
              meta: { 
                breadcrumbs: [
                    {
                    text: 'Trang chủ',
                    disabled: false,
                    to: {
                        name: "Home",
                        }
                    },
                    {
                    text: 'DS nhân viên hoạt động',
                    disabled: true,
                    to: {
                        name: "CurrentEmployee",
                        }
                    },
                ],
                icon:{
                    icon: "mdi-plus-thick",
                    to: ""
                },
              }
            },
            // ...Salary,
            // ...Allowance,
          ]
        },
        
        //*************** BENEFITS */
        {
          path: 'benefits/insurances',
          name: 'Insurance',
          component: Insurance,
          meta:{
            breadcrumbs: [
              {
              text: 'Trang chủ',
              disabled: false,
              to: {
                  name: "Home",
                  }
              },
              {
              text: 'Quản lí bảo hiểm ',
              disabled: true,
              to: {
                  name: "Insurance",
                  }
              },
            ],
          }
        },
        
        {
          path: 'benefits/year-leave-report',
          name: 'YearLeaveReport',
          component: YearLeaveReport
        },

        {
          path: 'benefits/contracts',
          name: 'Contract',
          component: Contract,
          meta: {
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
            ],
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },
          }
        },
        {
          path: 'benefits/contracts-v2/new',
          name: 'Contractv2',
          component: Contractv2,
          meta: {
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
            ],
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },
          }
        },
        {
          path: 'benefits/contracts-v2/pending',
          name: 'Contractv2Pending',
          component: Contractv2Pending,
          meta: {
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
            ],
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },
          }
        },
        {
          path: 'benefits/contracts-v2/ready',
          name: 'Contractv2Ready',
          component: Contractv2Ready,
          meta: {
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
            ],
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },
          }
        },
        {
          path: 'benefits/contracts-v2/return',
          name: 'Contractv2Return',
          component: Contractv2Return,
          meta: {
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
            ],
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },
          }
        },
        {
          path: 'benefits/contracts-v2/complete',
          name: 'Contractv2Complete',
          component: Contractv2Complete,
          meta: {
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
            ],
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },
          }
        },
        {
          path: 'benefits/contracts-v2/resign',
          name: 'Contractv2Resign',
          component: Contractv2Resign,
          meta: {
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
            ],
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },
          }
        },
        
        {
          path: 'benefits/leave-schedule',
          name: 'LeaveSchedule',
          component: LeaveSchedule,
        },
        
        {
          path: 'employee-ip',
          name: 'EmployeeIp',
          component: EmployeeIp,
        },

        {
          path: 'benefits/benefit-manager',
          name: 'BenefitManager',
          component: BenefitManager,
          meta: { 
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
                {
                text: 'Cấp phát nhân viên',
                disabled: true,
                to: {
                    name: "EmployeeIssue",
                    }
                },
            ],
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },
          }
        },
        
        {
          path: 'benefits/employee-issue',
          name: 'EmployeeIssue',
          component: EmployeeIssue,
          meta: { 
            breadcrumbs: [
                {
                text: 'Trang chủ',
                disabled: false,
                to: {
                    name: "Home",
                    }
                },
                {
                text: 'Cấp phát nhân viên',
                disabled: true,
                to: {
                    name: "EmployeeIssue",
                    }
                },
            ],
            icon:{
                icon: "mdi-plus-thick",
                to: ""
            },
          }
        },
        
        ...LeaveEnroll,
      ]
    },
    
  ]
